<template>
    <div class="text-center">
      <!-- Loading -->
      <div v-if="loading" class="col-12 text-center py-2">
        <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
        <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
        <b-spinner small label="Small Spinner" type="grow" variant="primary"></b-spinner>
      </div>
  
      <!-- End Loading -->
      <div class="table-responsive async-tables mt-2 text-center" v-if="showHtmlTable">
        <b-table  
          show-empty
          hover
          small
          bordered
          stacked-sm
          :items="table.body" 
          :fields="table.header"
          :sort-by.sync="sortBy"
          :sort-desc.sync="sortDesc"
          selectable
          select-mode="multi"
          @row-clicked="item=>onRowSelected(item)"
          id="reviews-table">
  
            <!-- A virtual column -->
            <template #cell(index)="data">
              <div class="text-left">
                {{ data.item.index }}
                <md-icon 
                  icon="star"
                  class="text-warning font-weight-bolder"
                  style="font-size: 12px; padding-bottom: 2px;"
                  v-if="data.item.star == true"/>
                <template v-if="data.item.row_type != 'end'">
                  <md-icon v-if="data.rowSelected"
                  icon="keyboard_arrow_down"
                  class="text-secondary font-weight-bolder"/>
                  <md-icon v-else
                  icon="keyboard_arrow_right"
                  class="text-secondary font-weight-bolder"/>
                </template>
                <div class="text-muted"><small>{{ data.item.domain }}</small></div>
              </div>
            </template>
  
            <!-- A virtual column -->
            <template #cell(reviews)="data">
              <div class="text-right">
                {{ number_format(data.item.reviews,0,'.',',') }}
              </div>
            </template>
  
            <!-- A virtual column -->
            <template #cell(average)="data">
              <div class="text-right">
                {{ number_format(data.item.average, 1) }}
                <md-icon 
                  icon="star"
                  class="text-warning font-weight-bolder"
                  style="font-size: 12px; padding-bottom: 2px;"/>
              </div>
            </template>
  
            <!-- A virtual column -->
            <template #cell(detalles)="data">
              <div class="text-center">
                <b-button variant="info" class="btn-sm mr-1" @click="showDetails(data)">
                  <small>Ver detalles</small>
                </b-button>
              </div>
            </template>
  
            <template #row-details="row">
              <div class="ml-2">
                <!--<button 
                  class="btn btn-info btn-sm float-right my-2" 
                  :data-ref="'table'+row.item.period">
                  Mostrar gráfica
                </button>
                -->
                <TableComponent :ref="'table'+row.item.index" @show-details="showDetails($event)"></TableComponent>
              </div>
              <!--<b-button size="sm" @click="row.toggleDetails">Hide Details</b-button>-->
            </template>
        </b-table>
      </div>
    </div>
  </template>
  
  <script>
  
    export default {
      name: "TableComponent",
      data() {
        return {
          sortBy: 'average',
          sortDesc: true,
          codeReport: 'reviews',
          loading: true,
          showHtmlTable: false,
          filters: {},
          table: {
            header: [
              {
                key: 'index',
                label: 'Indice',
                sortable: true
              },
              {
                key: 'reviews',
                label: 'Reseñas',
                sortable: true
              },
              {
                key: 'average',
                label: 'Score',
                sortable: true,
                variant: 'info'
              },
              'detalles'
            ],
            body: []
          },
        }
      },
      methods: {
        loadTable(filters) {
          this.filters = filters
          this.fetchData(filters)
        },
        fetchData(filters) {

          this.$root.api.get(`/reports/${this.codeReport}`, {
            params: {filters}
          }).then(res => {
            this.showHtmlTable = true
  
            let data = res.data.body;
            let body = []
            for (const group in data) {
              data[group].index = data[group].index.substring(0, 30);
              body.push(data[group])
            }
  
            this.table.body = body
          })
          .catch(error => {
            this.$root.handleRequestError(error);
          })
          .finally(() => {
            this.loading = false;
          });
        },
        showDetails(data) {
          // Send data to parent
          this.$emit('show-details', data)
        },
        onRowSelected(item) {
          if (item.row_type == 'end') {
            console.log('Se dio click a un row que ya no lista hijos');
            return false
          }
  
          this.$set(item, '_showDetails', !item._showDetails)
          this.$nextTick(() => {
            if (item._showDetails) {
              const childComponent = this.$refs['table'+item.index];
              if (childComponent) {
                this.filters.parent      = item.row_type
                this.filters.index       = item.index
                this.filters.parent_row  = item.parent_row
                this.filters.platform    = item.platform
                this.filters.supplier    = item.supplier
                this.filters.destination = item.destination
  
                childComponent.loadTable(this.filters)
              } else {
                console.error('Table Child component reference is undefined.');
              }
            }
          })
        },
        rowClass(item) {
          if (item != 'undefined' || item != null) {
            if (item.profit < 0) {
              return 'table-danger'
            }
          }
        },
        number_format (number, decimals, dec_point, thousands_sep) {
          // Strip all characters but numerical ones.
          number = (number + '').replace(/[^0-9+\-Ee.]/g, '');
          var n = !isFinite(+number) ? 0 : +number,
          prec  = !isFinite(+decimals) ? 0 : Math.abs(decimals),
          sep   = (typeof thousands_sep === 'undefined') ? ',' : thousands_sep,
          dec   = (typeof dec_point === 'undefined') ? '.' : dec_point,
          s     = '',
          toFixedFix = function (n, prec) {
              var k = Math.pow(10, prec);
              return '' + Math.round(n * k) / k;
          };
          
          // Fix for IE parseFloat(0.55).toFixed(0) = 0;
          s = (prec ? toFixedFix(n, prec) : '' + Math.round(n)).split('.');
          if (s[0].length > 3) {
            s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
          }
  
          if ((s[1] || '').length < prec) {
            s[1] = s[1] || '';
            s[1] += new Array(prec - s[1].length + 1).join('0');
          }
  
          return s.join(dec);
        },
      }
    }
  
  </script>